module.exports = __webpack_public_path__ + "img/Untitled.0df76b10.gif";